import { useFormContext } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/shared/components/ui/form'
import { Input } from '@/shared/components/ui/input'
import { LocationFields } from '@/shared/components/location-fields/LocationFields'
import type { CreateBusinessFormValues } from '../../schemas/createBusinessSchema'

/**
 * Paso de dirección del wizard de creación de negocio adicional. Captura la
 * dirección física del nuevo negocio (no de la organización). El JSX coincide
 * con el AddressStep del wizard de organización, pero tipado a
 * `CreateBusinessFormValues` para que react-hook-form encuentre `address` en
 * este form.
 */
export function AddressStep() {
  const { control } = useFormContext<CreateBusinessFormValues>()

  return (
    <div className="grid gap-5 sm:grid-cols-2">
      <div className="sm:col-span-2">
        <FormField
          control={control}
          name="address.street1"
          render={({ field }) => (
            <FormItem>
              <FormLabel required>Dirección</FormLabel>
              <FormControl>
                <Input required placeholder="Ej. Calle 23 #456" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FormField
        control={control}
        name="address.city"
        render={({ field }) => (
          <FormItem>
            <FormLabel required>Ciudad</FormLabel>
            <FormControl>
              <Input required placeholder="Ej. La Habana" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <LocationFields />

      <p className="text-xs text-ink-muted sm:col-span-2">
        Esta es la dirección física del nuevo negocio. Si tiene la misma dirección
        que la organización, puedes copiar los datos manualmente.
      </p>
    </div>
  )
}
